const translations = {
  sw: {
    nav: {
      dashboard: 'Dashibodi',
      groups: 'Vikundi',
      members: 'Wanachama',
      transactions: 'Michango',
      calendar: 'Kalenda',
      import: 'Import',
      fines: 'Faini',
      changiwa: 'Changiwa',
      users: 'Watumiaji',
      settings: 'Mipangilio',
      report: 'Ripoti',
      distribution: 'Mgawanyo',
      expenses: 'Matumizi',
      auditLog: 'Ukaguzi wa Mfumo',
      smsLogs: 'Logs za SMS',
      permissions: 'Ruhusa za Mfumo',
      groupRequests: 'Maombi ya Vikundi',
      notifications: 'Arifa',
      systemSettings: 'Mipangilio ya Mfumo',
      logout: 'Toka',
      more: 'More',
      menu: 'Menu',
    },
    role: {
      superadmin: 'Msimamizi Mkuu',
      admin: 'Msimamizi',
      member: 'Mwanachama',
    },
    common: {
      save: 'Hifadhi',
      cancel: 'Ghairi',
      delete: 'Futa',
      edit: 'Hariri',
      add: 'Ongeza',
      search: 'Tafuta',
      loading: 'Inapakia...',
      error: 'Hitilafu',
      success: 'Imefanikiwa',
      noData: 'Hakuna data',
      confirm: 'Thibitisha',
      close: 'Funga',
      back: 'Rudi',
      actions: 'Vitendo',
      name: 'Jina',
      phone: 'Simu',
      amount: 'Kiasi',
      date: 'Tarehe',
      type: 'Aina',
      status: 'Hali',
      active: 'Hai',
      inactive: 'Amezuiwa',
      all: 'Zote',
      filter: 'Chuja',
      export: 'Hamisha',
      import: 'Ingiza',
      total: 'Jumla',
      count: 'Idadi',
      yes: 'Ndiyo',
      no: 'Hapana',
      view: 'Angalia',
      saving: 'Inahifadhi...',
      selectGroup: 'Chagua kikundi kwanza',
      selectGroupOption: '-- Chagua Kikundi --',
      user: 'Mtumiaji',
    },
    layout: {
      welcome: 'Karibu',
      switchGroup: 'Badilisha Kikundi',
      chooseGroup: 'Chagua kikundi unachotaka kuingia',
      currentGroup: 'Sasa hivi',
      appLabel: 'M-Koba Mobile',
      roleLabel: 'Jukumu',
      errFetchGroups: 'Imeshindwa kupata vikundi',
      errSwitchGroup: 'Imeshindwa kubadilisha kikundi',
      switchGroupTitle: 'Badilisha kikundi',
    },
    sidebar: {
      tagline: 'Simamia kikundi chako popote ulipo',
      quickMenu: 'Menu ya haraka',
      moreMenu: 'Menyu zaidi',
    },
    dash: {
      title: 'Dashibodi ya Mfumo',
      titleGroup: 'Dashibodi ya Kikundi',
      titleMember: 'Michango Yangu',
      subtitleSuper: 'Mwonekano wa jumla wa vikundi, wanachama, na fedha zote.',
      subtitleAdmin: 'Fuata wanachama, michango, na mwelekeo wa kikundi chako kwa haraka.',
      subtitleMember: 'Hapa unaona historia na mwenendo wa michango yako.',
      badgeSuper: 'Msimamizi Mkuu',
      badgeAdmin: 'Admin wa Kikundi',
      badgeMember: 'Mwanachama',
      members: 'Wanachama',
      contributions: 'Miamala',
      groups: 'Vikundi',
      totalAll: 'Jumla Yote',
      monthlyFees: 'Ada za Mwezi',
      monthlyFeesDesc: 'Michango ya kawaida peke yake',
      entryFee: 'Kiingilio',
      entryFeeDesc: 'Ada za kuingia kikundi',
      totalAllDesc: 'Ada + Kiingilio pamoja',
      groupTransfers: 'Matumizi (Withdraws)',
      groupTransfersDesc: 'Pesa zilizotolewa kwa wanachama',
      netBalance: 'Salio la Kikundi',
      netBalanceDesc: 'Jumla yote baada ya kutoa malipo',
      myContributions: 'Jumla Nililochangia',
      myCount: 'Idadi ya Michango',
      scrollDown: 'Teleza chini',
      history: 'Historia ya Michango',
      monthlyChart: 'Michango kwa Mwezi',
      noTransactions: 'Hakuna miamala bado',
      allGroups: 'Vikundi Vyote',
      groupMembers: 'Wanachama',
      groupTotal: 'Jumla',
      distCard: 'Mgawanyo wa Kikundi',
      distCardTitle: 'Nitapata Nini?',
      distCardDesc: 'Angalia sehemu yako iwapo kikundi kitavunjwa',
      myFines: 'Faini Zangu Zinazodaiwa',
      finesCard: 'Una Faini za Kulipa',
      finesCardDesc: 'Bofya kuona na kulipa faini zako',
      noFines: 'Huna faini kwa sasa',
    },
    members: {
      title: 'Wanachama',
      addMember: '+ Mwanachama Mpya',
      newMember: 'Mwanachama Mpya',
      memberName: 'Jina Kamili',
      phone: 'Nambari ya Simu',
      email: 'Barua pepe',
      joinDate: 'Tarehe ya Kuingia',
      role: 'Nafasi',
      totalContributed: 'Michango',
      entryFee: 'Kiingilio',
      paidFee: 'Hajalipa',
      deleteConfirm: 'Futa mwanachama huyu?',
      searchPlaceholder: 'Tafuta jina au simu...',
      noMembers: 'Hakuna wanachama waliooana',
      chooseGroupFirst: 'Chagua kikundi kwanza',
      recordEntryFee: 'Rekodi Kiingilio',
      entryFeeDesc: 'Ada hii haitahesabika kwenye michango ya mwezi',
      entryFeeAmount: 'Kiasi cha Kiingilio (TZS)',
      defaultEntryFee: 'Kiingilio cha kawaida',
      sendSms: 'Tuma SMS ya Kuingia',
      allMembers: 'Wote',
      oneBy: 'Mmoja',
      searchMember: 'Tafuta jina au namba...',
      noMemberFound: 'Hakuna mwanachama',
      smsPreview: 'SMS itakayotumwa',
      sendAll: 'Tuma Wote',
      send: 'Tuma',
      sending: 'Inatuma...',
      idNumber: 'Nambari ya Kitambulisho',
      adding: 'Inaongeza...',
      saving: 'Inahifadhi...',
      errAdd: 'Imeshindwa kuongeza mwanachama',
      errEntryFee: 'Imeshindwa kurekodi kiingilio',
    },
    trans: {
      title: 'Michango',
      import: 'Import CSV',
      addTransaction: '+ Rekodi Mchango',
      recordTransaction: 'Rekodi Mchango',
      transId: 'TRANS ID',
      receipt: 'Receipt',
      memberName: 'Mwanachama',
      amount: 'Kiasi (TZS)',
      type: 'Aina ya Mchango',
      date: 'Tarehe na Saa',
      notes: 'Maelezo',
      source: 'Chanzo',
      destination: 'Lengwa',
      filter: 'Chuja',
      filterAll: '-- Mwanachama Wote --',
      filterAllTypes: '-- Aina Zote --',
      dateFrom: 'Kuanzia',
      dateTo: 'Hadi',
      exportCsv: 'Hamisha CSV',
      deleteConfirm: 'Futa mchango huu?',
      noTransactions: 'Hakuna michango',
      monthlyFees: 'Historia',
      entryFee: 'Kiingilio',
      totalAll: 'Jumla Yote',
      transCount: 'Miamala',
      records: 'rekodi',
      pivotTab: 'Ripoti ya Miezi',
      monthlyTab: 'Kwa Mwezi',
      listTab: 'Orodha',
      member: 'Mwanachama',
      total: 'Jumla',
      monthTotal: 'Jumla ya Mwezi',
      allocationNote: 'Ripoti hii sasa inagawa malipo kwa mwezi unaodaiwa kwanza, kama ilivyo kwenye `Ripoti ya Kila Mwezi`. Ada ya mwezi ni',
      search: 'Tafuta',
      saving: 'Inahifadhi...',
      errRecord: 'Imeshindwa kurekodi mchango',
      payments: 'malipo',
      chooseGroup: '-- Chagua Mwanachama --',
    },
    groups: {
      title: 'Vikundi',
      addGroup: '+ Kikundi Kipya',
      newGroup: 'Kikundi Kipya',
      name: 'Jina la Kikundi',
      namePlaceholder: 'mfano: BLESSING FAMILY',
      code: 'Nambari/Msimbo wa Kikundi',
      accountNumber: 'Nambari ya Akaunti (M-Pesa / Benki)',
      accountPlaceholder: '060243280129',
      description: 'Maelezo',
      cycleType: 'Aina ya Mzunguko',
      members: 'Wanachama',
      total: 'Jumla michango',
      settings: 'Mipangilio',
      viewDetail: 'Angalia →',
      deleteConfirm: 'Wanachama na miamala yote itafutwa.',
      noGroups: 'Hakuna vikundi bado. Unda kikundi kipya.',
      creating: 'Inaunda...',
      create: 'Unda',
      errCreate: 'Imeshindwa kuunda kikundi',
      number: 'Nambari',
    },
    settings: {
      title: 'Mipangilio',
      groupName: 'Jina la Kikundi',
      groupCode: 'Msimbo wa Kikundi',
      cycleType: 'Mzunguko wa Kikundi',
      startDate: 'Tarehe ya Kuanza (Mwezi wa Kwanza wa Michango)',
      endDate: 'Tarehe ya Kufunga',
      contributionsFrom: 'Hesabu Michango Kuanzia',
      contributionsFromNote: 'michango ya kabla ya tarehe hii haitahesabika (acha tupu kwa kawaida)',
      monthlyContribution: 'Ada ya Kila Mwezi (TZS)',
      entryFee: 'Ada ya Kiingilio (TZS)',
      entryFeeNote: 'haitahesabika kwenye ada za mwezi',
      openingBalance: 'Salio la Awali (TZS)',
      openingBalanceNote: 'fedha zilizokuwepo kabla ya kuanza kurekodi',
      dissolveAtEnd: 'Kikundi kitavunjika mwisho wa mzunguko (kugawana pesa)',
      reserveMonths: 'Hifadhi miezi mingapi kabla ya kugawana?',
      reserveZero: '(0 = gawana yote)',
      reserveMonthsNote: 'Ada ya miezi {n} itabakishwa kama mwanzo wa mzunguko ujao. Pia miezi {n} ya kwanza ya mzunguko mpya haitahesabiwa kama ada inayodaiwa (miezi ya neema).',
      dueDay: 'Siku ya Kulipa kwa Mwezi',
      dueDayNote: 'ya kila mwezi',
      graceDays: 'Siku za Ziada (Grace Period)',
      graceDaysNote: 'siku',
      fineType: 'Aina ya Faini',
      fineFixed: 'Kiasi Maalum (TZS)',
      finePercent: 'Asilimia (%)',
      fineAmount: 'Kiasi cha Faini (TZS)',
      finePercentLabel: 'Asilimia ya Faini (%)',
      finePercentNote: '% ya ada ya mwezi',
      fineAuto: 'Ingiza faini kiotomatiki',
      fineAutoNote: 'Mfumo utaingiza faini mara moja unapofungua ukurasa wa faini',
      leaders: 'Viongozi wa Kikundi',
      leadersDesc: 'Chagua wanachama wanaoshikilia nafasi za uongozi. Majina yao yataonekana kwenye ukurasa wa kikundi.',
      chooseLeader: '— Chagua mwanachama —',
      saveLeaders: 'Hifadhi Viongozi',
      savingLeaders: 'Inahifadhi...',
      saveCycle: 'Hifadhi Mzunguko',
      savingCycle: 'Inahifadhi...',
      saveFine: 'Hifadhi Mipangilio ya Faini',
      savingFine: 'Inahifadhi...',
      changiwaTypes: 'Aina za Changiwa (Katiba)',
      changiwaTypesDesc: 'Fafanua aina za mchango maalum — kila mwanachama atalazimika kulipa kiasi hiki tukiwa na tukio.',
      noChangiwaTypes: 'Hakuna aina za changiwa bado',
      addChangiwaType: '+ Ongeza Aina ya Changiwa',
      addNewType: 'Ongeza Aina Mpya',
      typeName: 'Jina',
      typeAmount: 'Kiasi kwa Mwanachama (TZS)',
      typeDesc: 'Maelezo (hiari)',
      typeNamePlaceholder: 'mfano: Msiba',
      typeAmountPlaceholder: 'mfano: 5000',
      typeDescPlaceholder: 'mfano: Msiba wa familia ya karibu',
      transferTypes: 'Aina za Malipo ya Kikundi (Group Transfer)',
      transferTypesDesc: 'Fafanua aina za malipo yanayotolewa moja kwa moja kutoka kwa kikundi kwa mwanachama aliyestahili — mfano: msaada wa msiba, harusi, ugonjwa.',
      noTransferTypes: 'Hakuna aina za malipo bado',
      addTransferType: '+ Ongeza Aina ya Malipo',
      addNewTransferType: 'Ongeza Aina Mpya ya Malipo',
      transferTypeName: 'Jina la Malipo',
      transferTypeAmount: 'Kiasi Kinachotolewa (TZS)',
      transferTypeDesc: 'Maelezo (hiari)',
      transferTypeNamePlaceholder: 'mfano: Msiba, Harusi, Ugonjwa',
      transferTypeAmountPlaceholder: 'mfano: 800000',
      transferTypeDescPlaceholder: 'mfano: Fao la msiba wa ndugu wa karibu',
      sms: 'Mawasiliano ya Kikundi',
      smsDesc: 'Tuma ujumbe wa SMS ili wanachama wajue jinsi ya kuingia mfumoni kwa OTP.',
      smsSendAll: 'Tuma kwa Wanachama Wote',
      smsSendOne: 'Tuma kwa Mwanachama Huyu',
      smsSending: 'Inatuma...',
      smsPreview: 'SMS itakayotumwa:',
      searchMember: 'Tafuta jina au namba ya simu...',
      noMemberFound: 'Hakuna mwanachama aliyepatikana',
      toastSavedCycle: 'Mipangilio ya mzunguko imehifadhiwa',
      toastSavedFine: 'Mipangilio ya faini imehifadhiwa',
      toastSavedLeaders: 'Viongozi wamehifadhiwa',
      toastSavedPerms: 'Ruhusa za wanachama zimehifadhiwa',
      toastErr: 'Imeshindwa kuhifadhi',
      toastErrLeaders: 'Imeshindwa kuhifadhi viongozi',
      fineInfo: 'Mfumo utaangalia kila mwezi kama wanachama wamelipa. Wale ambao hawajalipa baada ya tarehe uliyoweka + siku za ziada watapewa faini.',
      months: 'miezi',
      memberPermsTitle: 'Ruhusa za Wanachama',
      memberPermsDesc: 'Chagua kurasa ambazo wanachama wataruhusiwa kuona.',
      savePerms: 'Hifadhi Ruhusa',
    },
    groupDetail: {
      members: 'Wanachama',
      totalContributions: 'Jumla Michango',
      transactions: 'Miamala',
      groupTransfers: 'Matumizi (Withdraws)',
      netBalance: 'Salio la Kikundi',
      kiingilio: 'Kiingilio',
      cycle: 'Mzunguko',
      monthlyFee: 'Ada ya Mwezi',
      leaders: 'Viongozi wa Kikundi',
      notFound: 'Kikundi hakikupatikana',
      viewMembers: 'Wanachama',
      viewContributions: 'Michango',
      viewFines: 'Faini',
      viewChangiwa: 'Changiwa',
      viewImport: 'Import CSV',
      viewMonthly: 'Ripoti ya Miezi',
      viewDistribution: 'Mgawanyo',
      viewSettings: 'Mipangilio',
      viewExpenses: 'Matumizi',
      expenses: 'Matumizi ya Kikundi',
      noMembers: 'Hakuna wanachama bado',
      totalContributed: 'Jumla Aliyochangia',
    },
    fines: {
      title: 'Faini za Wanachama',
      subtitle: 'Fuatilia faini zinazodaiwa, zilizosamehewa, na zilizolipwa kwa kila mwanachama.',
      badgeLabel: 'Penalty Control',
      checkFines: 'Angalia Faini za Mwezi',
      checking: 'Inaangalia...',
      addFine: '+ Weka Faini',
      manualFine: 'Weka Faini kwa Mkono',
      member: 'Mwanachama',
      period: 'Mwezi',
      reason: 'Sababu',
      reasonPlaceholder: 'mfano: Kuchelewa kulipa ada ya Januari',
      amount: 'Kiasi (TZS)',
      type: 'Aina',
      statusLabel: 'Hali',
      actions: 'Vitendo',
      pending: 'Inadaiwa',
      paid: 'Imelipwa',
      waived: 'Imesamehewa',
      pay: 'Lipa',
      waive: 'Samehe',
      delete: 'Futa',
      deleteConfirm: 'Futa faini hii?',
      noFines: 'Hakuna faini',
      pendingCount: 'Inadaiwa',
      pendingCountLabel: 'idadi ya faini',
      pendingTotal: 'Jumla',
      pendingTotalLabel: 'TZS inayodaiwa',
      chooseGroup: '-- Kikundi --',
      allStatus: '-- Hali Zote --',
      auto: 'Auto',
      manual: 'Manual',
      fineMonth: 'Mwezi',
      fineMember: 'Mwezi',
      saving: 'Inaingiza...',
      submit: 'Ingiza Faini',
      errCreate: 'Imeshindwa kuingiza faini',
      chooseFirst: 'Chagua kikundi kwanza',
      chooseSelect: '-- Chagua --',
    },
    cal: {
      title: 'Kalenda ya Michango',
      noEvents: 'Bonyeza siku kwenye kalenda kuona michango',
      noPaymentsDay: 'Hakuna michango siku hii',
      topContributors: 'Waliochanga Zaidi Mwezi Huu',
      summary: 'Muhtasari',
      totalMonth: 'TZS zilizokusanywa',
      daysReceived: 'zilipokea michango',
      dayTotal: 'Jumla ya Siku',
      monthTotal: 'Jumla',
      daysWithPayments: 'Siku {n} za malipo',
      less: 'Kidogo',
      more: 'Zaidi',
      payments: 'malipo',
      chooseGroup: 'Chagua kikundi kwanza',
    },
    changiwa: {
      title: 'Changiwa',
      addEvent: '+ Tukio Jipya',
      newEvent: 'Tukio Jipya la Changiwa',
      noTypes: 'Hakuna aina za changiwa zilizowekwa.',
      goSettings: 'Nenda Mipangilio',
      noEvents: 'Hakuna matukio ya changiwa bado.',
      noEventsHint: 'Bonyeza "+ Tukio Jipya" kuanza.',
      typeLabel: 'Aina ya Changiwa',
      typeSelect: '-- Chagua aina --',
      title_label: 'Kichwa cha Habari',
      titlePlaceholder: 'mfano: Msiba wa mama yake JACKSON MMASI',
      beneficiary: 'Mhusika (hiari)',
      beneficiarySelect: '-- Chagua au acha wazi --',
      eventDate: 'Tarehe',
      amountPerMember: 'Kiasi kwa Mwanachama (TZS)',
      amountNote: 'Wanachama {n} × kiasi = jumla inayotarajiwa',
      notes: 'Maelezo (hiari)',
      paid: 'wmelipa',
      disbursed: 'Imelipwa kwa mhusika',
      disbursedNote: 'imesajiliwa kama matumizi ya kikundi',
      viewPayments: 'Angalia Malipo',
      close: 'Funga',
      deleteConfirm: 'Malipo yote yatafutwa.',
      creating: 'Inaunda...',
      createEvent: 'Unda Tukio',
      errCreate: 'Imeshindwa kuunda tukio',
      chooseGroup: 'Chagua kikundi kwanza',
    },
    changiwaDetail: {
      back: 'Changiwa',
      notFound: 'Tukio halikupatikana',
      beneficiary: 'Mhusika',
      collected: 'wmelipa',
      progress: 'imekusanywa',
      expected: 'Inatarajiwa',
      disbursed: 'Imelipwa kwa Mhusika',
      disbursedNote: 'imesajiliwa kama matumizi ya kikundi',
      payAll: 'Weka Wote Kama Wamelipa',
      disburse: 'Lipa kwa',
      pending: 'Hawajalipa',
      paidSection: 'Wamelipa',
      waived: 'Waliosamehewa',
      pay: 'Lipa',
      waive: 'Samehe',
      confirmPayAll: 'Weka wote kama wamelipa?',
      disbursedAt: 'imesajiliwa kama matumizi ya kikundi',
    },
    dist: {
      title: 'Mgawanyo wa Pesa',
      subtitle: 'Muhtasari wa mapato, matumizi, na kiasi anachopokea kila mwanachama mwisho wa mzunguko.',
      totalCollected: 'Jumla ya michango iliyokusanywa',
      finesIncome: 'Faini zilizolipwa (mapato)',
      totalIncome: 'Jumla ya mapato yote',
      expenses: 'Matumizi ya kikundi',
      groupTransfersDed: 'Malipo ya msaada (Group Transfer)',
      reserve: 'Hifadhi (miezi {n} × wanachama {m})',
      toDistribute: 'Kiasi cha kugawanywa',
      summary: 'Muhtasari wa Hesabu',
      currentBalance: 'Salio halisi la kikundi (M-Pesa)',
      reserveNeeded: 'Akiba inayohitajika (miezi {n})',
      reserveSurplus: 'Ziada ya akiba',
      reserveShortfall: 'Upungufu wa akiba',
      myShare: 'Sehemu Yangu',
      contributed: 'Nililochangia',
      pendingFines: 'Faini inayodaiwa',
      perMember: 'Mgawanyo kwa Kila Mwanachama',
      alreadyDistributed: 'Mzunguko huu umefungwa na pesa zimegawanywa.',
      closeCycle: 'Funga Mzunguko na Gawanya Pesa',
      closing: 'Inafunga...',
      closeWarning: 'Baada ya kugawanya pesa, bonyeza kitufe hapa chini kufunga mzunguko huu. Kikundi kitaanzisha upya mzunguko mpya.',
      confirmClose: 'Una uhakika unataka kufunga mzunguko huu? Hatua hii haiwezi kurudishwa.',
      receives: 'Anapokea',
      totalDist: 'Jumla ya Kugawanywa',
      pendingFinesCol: 'Faini Inayodaiwa',
      contributedCol: 'Aliyochangia',
      memberCol: 'Mwanachama',
      me: 'Mimi',
    },
    importCsv: {
      title: 'Import CSV ya M-Pesa',
      back: 'Rudi',
      instructions: 'Maelekezo:',
      instrStep1: 'Pakua CSV kutoka M-Pesa / CBS',
      instrStep2: 'Safu zinazohitajika: TRANS_ID, RECEIPT, DATE, MEMBER NAME, MEMBER ID, SOURCE, DESTINATION, AMOUNT, TRANS TYPE',
      instrStep3: 'Miamala iliyopo tayari (TRANS_ID ileile) itarukiwa',
      instrStep4: 'Wanachama wapya wataundwa kiotomatiki kutoka nambari za simu',
      groupLabel: 'Kikundi',
      groupSelect: '-- Chagua Kikundi --',
      fileLabel: 'Faili la CSV',
      fileClick: 'Bonyeza hapa kuchagua faili la CSV',
      fileDrop: 'au drag & drop',
      submit: 'Ingiza CSV',
      submitting: 'Inaingiza...',
      success: 'Imekamilika!',
      imported: 'Miamala iliyoingizwa',
      skipped: 'Iliyorukiwa (tayari ipo)',
      viewTransactions: 'Angalia Michango →',
      errNoGroup: 'Chagua kikundi kwanza',
      errNoFile: 'Chagua faili la CSV',
      errImport: 'Imeshindwa kuingiza CSV',
    },
    users: {
      title: 'Watumiaji',
      addUser: '+ Mtumiaji Mpya',
      newUser: 'Mtumiaji Mpya',
      fullName: 'Jina Kamili',
      phone: 'Nambari ya Simu',
      phonePlaceholder: '255715465042',
      phoneNote: 'Tumia muundo `255XXXXXXXXX`. Ukiandika `07XXXXXXXX`, mfumo utageuza kuwa `255XXXXXXXXX` kabla ya kuhifadhi.',
      password: 'Nywila',
      role: 'Jukumu',
      group: 'Kikundi',
      groupSelect: '-- Chagua --',
      active: 'Hai',
      inactive: 'Amezuiwa',
      status: 'Hali',
      roleLabel: 'Jukumu',
      superadmin: 'Msimamizi Mkuu',
      adminGroup: 'Msimamizi wa Kikundi',
      memberRole: 'Mwanachama',
      deleteConfirm: 'Futa mtumiaji',
      noUsers: 'Hakuna watumiaji',
      creating: 'Inaunda...',
      create: 'Unda',
      errCreate: 'Imeshindwa kuunda mtumiaji',
      errPhone: 'Nambari ya simu lazima iwe kwenye muundo 255XXXXXXXXX',
      errSave: 'Imeshindwa kuhifadhi mabadiliko',
      editUser: 'Hariri Mtumiaji',
      newPassword: 'Nywila Mpya',
      optional: 'si lazima',
      passwordPlaceholder: 'Acha wazi kama hutabadilisha',
      addToGroup: 'Ongeza Kikundi',
      addToGroupTitle: 'Ongeza Mtumiaji kwenye Kikundi',
      addToGroupSub: 'Mtumiaji ataweza ku-switch kati ya vikundi vyake',
      selectRole: 'Chagua Jukumu',
      addToGroupBtn: 'Ongeza',
      addingToGroup: 'Inaongeza...',
      errAddToGroup: 'Imeshindwa kuongeza kwenye kikundi',
      addToGroupSuccess: 'Ameongezwa kikundi kipya',
      memberRoles: {
        mwenyekiti: 'Mwenyekiti (Admin)',
        katibu: 'Katibu',
        mwekahazina: 'Mweka Hazina',
        mwanachama: 'Mwanachama (Member)',
      },
    },
    report: {
      title: 'Ripoti ya Kila Mwezi',
      subtitle: 'Angalia hali ya kila mwanachama kwa miezi yote, magepu, malipo kamili, na nusu ya malipo.',
      member: 'Mwanachama',
      total: 'Jumla',
      totalMonth: 'Jumla ya Mwezi',
      paid: 'Sawa',
      paidCells: 'seli zilizolipwa',
      gap: 'Pengo',
      gapCells: 'haujalipiwa',
      partial: 'Nusu',
      partialCells: 'nusu malipo',
      feeLabel: 'Ada',
      membersWithGaps: 'Wanachama wenye Magepu',
      gapLabel: 'Magepu',
      debtLabel: 'Deni',
      openReport: 'Fungua',
      reportCalendar: 'Kalenda ya Ripoti',
      reportCalendarHint: 'Bonyeza kufungua fullscreen uone miezi yote.',
      closeFS: 'Funga',
      gapCount: 'pengo',
      cannotShow: 'Haiwezi kuonyesha ripoti',
      goSettings: 'Nenda Mipangilio →',
    },
    memberDetail: {
      title: 'Muhtasari wa mwanachama, hali ya miezi, na historia ya michango.',
      back: 'Wanachama',
      phone: 'Simu',
      email: 'Barua pepe',
      role: 'Nafasi',
      status: 'Hali',
      active: 'Hai',
      inactive: 'Amezuiwa',
      joined: 'Aliingia',
      totalContributed: 'Jumla Aliyochangia',
      countContributions: 'Idadi ya Michango',
      msibaPaid: 'Msaada wa Maombolezo Aliopata',
      balance: 'Amezidi / Sawa',
      debt: 'Deni lake',
      gapMonths: 'Miezi Haijalipiwa',
      monthlyStatus: 'Hali ya Kila Mwezi',
      history: 'Historia ya Michango',
      noTransactions: 'Hakuna michango bado',
      notFound: 'Mwanachama hakupatikana',
      statusPaid: 'Amelipa',
      statusPartial: 'Nusu',
      statusGap: 'Hajalipa',
      statusFuture: 'Bado',
    },
    expenses: {
      title: 'Matumizi ya Kikundi',
      subtitle: 'Gharama za uendeshaji na malipo ya msiba',
      summaryRegular: 'Matumizi ya kawaida',
      summaryMsiba: 'Malipo ya Msiba',
      addBtn: '+ Ingiza Malipo Mapya',
      formTitle: 'Malipo Mapya',
      typeLabel: 'Aina ya Malipo',
      typeRegular: '🧾 Matumizi ya kawaida',
      typeMsiba: '🏥 Malipo ya Msiba',
      msibaTypeLabel: 'Aina ya Msiba',
      msibaTypeSelect: '— Chagua aina ya msiba —',
      memberLabel: 'Mwanachama Aliyepata Msaada *',
      memberSelect: '— Chagua mwanachama —',
      descLabel: 'Maelezo *',
      descPlaceholder: 'mfano: Gharama za mkutano, Usafiri…',
      notesLabel: 'Maelezo Zaidi (hiari)',
      notesLabelMsiba: 'Maelezo Zaidi',
      notesPlaceholderMsiba: 'mfano: Msiba wa mama yake',
      notesPlaceholder: 'Taarifa yoyote ya ziada…',
      typesMgmt: 'Aina za Msiba',
      typesCount: 'aina zilizowekwa',
      typesEmpty: 'Hakuna aina zilizoongezwa bado',
      typeNamePlaceholder: 'Jina la aina (mfano: Msiba wa shangazi)',
      typeAmountPlaceholder: 'Kiasi',
      typeAddBtn: '+ Ongeza',
      sectionRegular: '🧾 Matumizi ya Kawaida',
      sectionMsiba: '🏥 Malipo ya Msiba',
      noRegular: 'Hakuna matumizi yaliyorekodiwa bado',
      noMsiba: 'Hakuna malipo ya msiba yaliyorekodiwa bado',
      deleteExpenseConfirm: 'Futa matumizi hii?',
      errAmount: 'Ingiza kiasi sahihi',
      errMember: 'Chagua mwanachama',
      errDesc: 'Ingiza maelezo',
      errSave: 'Imeshindwa kuhifadhi',
      saving: 'Inahifadhi…',
      close: 'Funga',
    },
    gt: {
      title: 'Matumizi / Withdraws',
      subtitle: 'Waliochangiwa mchango wa kikundi',
      totalDisbursed: 'Jumla Iliyotolewa',
      payments: 'malipo',
      addBtn: '+ Ongeza Malipo',
      addModalTitle: 'Ingiza Malipo ya Mchango wa Msaada',
      editModalTitle: 'Hariri Malipo',
      memberLabel: 'Mwanachama Aliyepata Msaada',
      memberSelect: '— Chagua mwanachama —',
      subTypeLabel: 'Aina ya Msaada',
      amountLabel: 'Kiasi (TZS)',
      amountPlaceholder: 'Mfano: 50000',
      dateLabel: 'Tarehe',
      notesLabel: 'Maelezo',
      notesPlaceholder: 'Mfano: Msiba wa mama yake / Harusi ya mtoto wake',
      cancel: 'Ghairi',
      save: 'Hifadhi',
      saving: 'Inahifadhi...',
      edit: 'Hariri',
      delete: 'Futa',
      empty: 'Hakuna malipo yaliyorekodiwa bado',
      total: 'Jumla',
      colMember: 'Jina la Mwanachama',
      colPhone: 'Simu',
      colType: 'Aina',
      colAmount: 'Kiasi',
      colDate: 'Tarehe',
      colNotes: 'Maelezo',
      errMember: 'Chagua mwanachama',
      errAmount: 'Ingiza kiasi sahihi',
      errSave: 'Imeshindwa kuhifadhi',
      errEdit: 'Imeshindwa kubadilisha',
      errDelete: 'Imeshindwa kufuta',
      confirmDelete: 'Futa malipo haya ya',
      confirmDeleteMsg: 'Hii itaondoa kumbukumbu hii kutoka kwenye mfumo.',
    },
    registerGroup: {
      title: 'Sajili Kikundi Kipya',
      subtitle: 'Ombi litapelekwa kwa superadmin kukubali',
      labelGroupName: 'Jina la Kikundi',
      placeholderGroupName: 'Mfano: BLESSINGS FAMILY',
      labelMemberCount: 'Idadi ya Wanachama',
      placeholderMemberCount: 'Mfano: 15',
      sectionChair: 'Taarifa za Mwenyekiti',
      labelChairName: 'Jina Kamili',
      placeholderChairName: 'Jina la mwenyekiti',
      labelChairPhone: 'Namba ya Simu',
      phoneHint: 'Namba hii itakuwa admin wa kikundi na itapokea SMS ya mwaliko',
      btnSubmit: 'Tuma Ombi →',
      btnSubmitting: 'Inatuma Ombi...',
      successTitle: 'Ombi Limepokelewa!',
      successMsg: 'Superadmin atakukagua ombi lako na utaarifiwa kupitia SMS baada ya kukubaliwa.',
      btnClose: 'Sawa, Asante!',
      errRequired: 'Jaza sehemu zote zinazohitajika',
      errDuplicate: 'Ombi lako bado lipo. Subiri idhini ya superadmin.',
      errPhoneExists: 'Namba hii ya simu tayari imesajiliwa kwenye mfumo. Ingia kwanza au wasiliana na msimamizi.',
      errGeneric: 'Imeshindwa kutuma ombi. Jaribu tena.',
    },
    groupRequests: {
      title: 'Maombi ya Vikundi',
      subtitle: 'Vikundi vinavyoomba kusajiliwa kwenye mfumo',
      filterPending: 'Inasubiri',
      filterApproved: 'Zilizokubaliwa',
      filterRejected: 'Zilizokataliwa',
      filterAll: 'Zote',
      loading: 'Inapakia...',
      empty: 'Hakuna maombi',
      labelGroupName: 'Kikundi',
      labelChair: 'Mwenyekiti',
      labelPhone: 'Simu',
      labelMembers: 'Wanachama',
      labelGroupId: 'Kikundi ID',
      labelRejectionNote: 'Sababu ya kukataliwa',
      btnApprove: '✅ Kubali Kikundi',
      btnApproving: 'Inakubali...',
      btnReject: '❌ Kataa',
      rejectTitle: 'Kataa Ombi',
      rejectLabel: 'Sababu (itatumwa kwa SMS)',
      rejectPlaceholder: 'Andika sababu hapa (hiari)...',
      btnConfirmReject: 'Kataa',
      btnRejecting: 'Inakataa...',
      btnCancel: 'Ghairi',
      toastApproved: 'Kikundi kimekubaliwa na SMS imetumwa kwa mwenyekiti!',
      toastRejected: 'Ombi limekataliwa.',
      statusPending: 'Inasubiri',
      statusApproved: 'Imekubaliwa',
      statusRejected: 'Imekataliwa',
    },
    auditLog: {
      title: 'Ukaguzi wa Mfumo',
      subtitle: 'Shughuli zote zilizofanywa na watumiaji',
      searchPlaceholder: 'Tafuta jina, simu au maelezo…',
      allActions: 'Vitendo vyote',
      from: 'Kuanzia',
      to: 'Hadi',
      clearFilters: 'Futa vichujio',
      totalRecords: 'Jumla ya rekodi',
      loading: 'Inapakia…',
      noData: 'Hakuna rekodi zilizopatikana',
      prev: 'Iliyopita',
      next: 'Inayofuata',
      page: 'Ukurasa',
      col: {
        time: 'Wakati',
        user: 'Mtumiaji',
        role: 'Nafasi',
        action: 'Kitendo',
        description: 'Maelezo',
        ip: 'Anwani ya IP',
      },
      actions: {
        login: 'Kuingia',
        create_transaction: 'Mchango Mpya',
        delete_transaction: 'Kufuta Mchango',
        create_member: 'Mwanachama Mpya',
        update_member: 'Kubadilisha Mwanachama',
        delete_member: 'Kufuta Mwanachama',
        create_expense: 'Matumizi Mapya',
        delete_expense: 'Kufuta Matumizi',
        update_user: 'Kubadilisha Mtumiaji',
        delete_user: 'Kufuta Mtumiaji',
        update_permissions: 'Kubadilisha Ruhusa',
      },
    },
    smsLogs: {
      title: 'Logs za SMS',
      subtitle: 'Angalia SMS zote zilizotumwa na mfumo — zilizofanikiwa na zilizofeli',
      searchPlaceholder: 'Tafuta namba ya simu au ujumbe…',
      allStatus: 'Hali zote',
      sent: 'Imetumwa',
      failed: 'Imefeli',
      from: 'Kuanzia',
      to: 'Hadi',
      clearFilters: 'Futa vichujio',
      totalRecords: 'Jumla ya SMS',
      loading: 'Inapakia…',
      noData: 'Hakuna SMS zilizopatikana',
      prev: 'Iliyopita',
      next: 'Inayofuata',
      page: 'Ukurasa',
      viewDetails: 'Angalia zaidi',
      hideDetails: 'Funga',
      col: {
        time: 'Wakati',
        phone: 'Namba ya Simu',
        message: 'Ujumbe',
        status: 'Hali',
        error: 'Hitilafu',
      },
    },
    systemSettings: {
      title: 'Mipangilio ya Mfumo',
      subtitle: 'Weka credentials za WhatsApp na SMS ili kutuma arifa kwa wanachama.',
      noChanges: 'Hakuna mabadiliko.',
      hasChanges: 'Una mabadiliko ambayo hayajahifadhiwa.',
      save: 'Hifadhi',
      saving: 'Inahifadhi...',
      saved: '✅ Mipangilio imehifadhiwa!',
      saveFailed: '❌ Imeshindwa kuhifadhi.',
      loadFailed: 'Imeshindwa kupakia mipangilio.',
      change: 'Badilisha',
      set: '+ Weka',
      notSet: 'Haijawekwa',
      testTitle: '🧪 Jaribu Muunganisho',
      testPhone: 'Nambari ya majaribio (255...)',
      test: 'Jaribu',
      testing: '...',
      testOk: '✅',
      testFail: '❌',
      providerLabel: 'Mtoa Huduma wa WhatsApp',
      providerHint: 'Chagua mtoa huduma utakaotumika kutuma ujumbe wa WhatsApp.',
      providers: { ultramsg: 'UltraMsg', wasender: 'WasenderAPI', meta: 'Meta (Rasmi)' },
      whatsapp: {
        title: 'WhatsApp — UltraMsg',
        hint: 'Ingia ultramsg.com, unda instance, kisha nakili Instance ID na Token hapa.',
        link: 'ultramsg.com ↗',
        fields: {
          whatsapp_instance_id: 'Instance ID',
          whatsapp_token: 'Token',
          whatsapp_url: 'API URL',
        },
      },
      wasender: {
        title: 'WhatsApp — WasenderAPI',
        hint: 'Ingia app.wasenderapi.com, unda session, kisha nakili API Key hapa.',
        link: 'wasenderapi.com ↗',
        fields: {
          wasender_api_key: 'API Key',
        },
      },
      meta: {
        title: 'WhatsApp — Meta (Rasmi)',
        hint: 'Tengeneza App kwenye developers.facebook.com, ongeza bidhaa ya "WhatsApp", kisha nakili Access Token (ya kudumu) na Phone Number ID kutoka WhatsApp → API Setup. Kisha weka Callback URL na Verify Token hapa chini kwenye sehemu ya "Webhook" ya App yako.',
        link: 'developers.facebook.com ↗',
        callbackLabel: 'Callback URL (Webhook)',
        fields: {
          meta_whatsapp_token: 'Access Token',
          meta_whatsapp_phone_number_id: 'Phone Number ID',
          meta_whatsapp_waba_id: 'WhatsApp Business Account ID (WABA ID)',
          meta_whatsapp_verify_token: 'Webhook Verify Token',
        },
      },
      sms: {
        title: 'SMS (messaging-service.co.tz)',
        hint: 'Akaunti ya NexByte/messaging-service.co.tz — wasiliana na msambazaji wako wa SMS.',
        fields: {
          sms_username: 'Jina la Mtumiaji (Username)',
          sms_password: 'Nywila (Password)',
          sms_from: 'Jina la Mtumaji (From)',
        },
      },
    },
    perms: {
      title: 'Ruhusa za Mfumo',
      subtitle: 'Weka ruhusa za wanachama na viongozi kwa kila kikundi',
      selectGroup: 'Chagua Kikundi',
      memberTitle: 'Wanachama Waone',
      memberDesc: 'Kurasa ambazo mwanachama anaweza kuona',
      adminTitle: 'Viongozi Wafanye',
      adminDesc: 'Vitendo ambavyo kiongozi anaweza kufanya',
      allOn: 'Wote',
      allOff: 'Funga',
      save: 'Hifadhi Ruhusa',
      saved: 'Imehifadhiwa',
      saveHint: 'Mabadiliko yataanza kutumika mara moja',
      member: {
        transactions:   { label: 'Michango',             desc: 'Waone michango yao' },
        fines:          { label: 'Faini',                desc: 'Waone faini zao' },
        changiwa:       { label: 'Changiwa',             desc: 'Waone matukio ya changiwa' },
        monthly_report: { label: 'Ripoti ya Kila Mwezi', desc: 'Waone ripoti ya malipo' },
        distribution:   { label: 'Mgawanyo',             desc: 'Waone mgawanyo wa mzunguko' },
      },
      admin: {
        add_transactions:    { label: 'Ongeza Michango',  desc: 'Waweze kuingiza michango mipya' },
        delete_transactions: { label: 'Futa Michango',    desc: 'Waweze kufuta michango' },
        add_members:         { label: 'Ongeza Wanachama', desc: 'Waweze kuongeza wanachama wapya' },
        deactivate_members:  { label: 'Zuia Wanachama',   desc: 'Waweze kuzuia wanachama' },
        delete_members:      { label: 'Futa Wanachama',   desc: 'Waweze kufuta wanachama kabisa' },
        manage_fines:        { label: 'Simamia Faini',    desc: 'Waweze kuongeza/kulipa/kufuta faini' },
        manage_changiwa:     { label: 'Simamia Changiwa', desc: 'Waweze kuunda na kusimamia matukio' },
        manage_expenses:     { label: 'Simamia Matumizi', desc: 'Waweze kuongeza na kufuta matumizi' },
        import_csv:          { label: 'Import CSV',       desc: 'Waweze ku-import michango kwa CSV' },
      },
    },
    errLoad: 'Imeshindwa kupakia',
    errSave: 'Imeshindwa kuhifadhi',
    errDelete: 'Imeshindwa kufuta',
    errNetwork: 'Hitilafu ya mtandao',
  },

  en: {
    nav: {
      dashboard: 'Dashboard',
      groups: 'Groups',
      members: 'Members',
      transactions: 'Contributions',
      calendar: 'Calendar',
      import: 'Import',
      fines: 'Fines',
      changiwa: 'Changiwa',
      users: 'Users',
      settings: 'Settings',
      report: 'Report',
      distribution: 'Distribution',
      expenses: 'Expenses',
      auditLog: 'Audit Trail',
      smsLogs: 'SMS Logs',
      permissions: 'Access Control',
      groupRequests: 'Group Requests',
      logout: 'Logout',
      more: 'More',
      menu: 'Menu',
      notifications: 'Notifications',
      systemSettings: 'System Settings',
    },
    role: {
      superadmin: 'Super Admin',
      admin: 'Admin',
      member: 'Member',
    },
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      search: 'Search',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      noData: 'No data',
      confirm: 'Confirm',
      close: 'Close',
      back: 'Back',
      actions: 'Actions',
      name: 'Name',
      phone: 'Phone',
      amount: 'Amount',
      date: 'Date',
      type: 'Type',
      status: 'Status',
      active: 'Active',
      inactive: 'Suspended',
      all: 'All',
      filter: 'Filter',
      export: 'Export',
      import: 'Import',
      total: 'Total',
      count: 'Count',
      yes: 'Yes',
      no: 'No',
      view: 'View',
      saving: 'Saving...',
      selectGroup: 'Select a group first',
      selectGroupOption: '-- Select Group --',
      user: 'User',
    },
    layout: {
      welcome: 'Welcome',
      switchGroup: 'Switch Group',
      chooseGroup: 'Choose the group you want to enter',
      currentGroup: 'Current',
      appLabel: 'M-Koba Mobile',
      roleLabel: 'Role',
      errFetchGroups: 'Failed to fetch groups',
      errSwitchGroup: 'Failed to switch group',
      switchGroupTitle: 'Switch group',
    },
    sidebar: {
      tagline: 'Manage your group anywhere',
      quickMenu: 'Quick menu',
      moreMenu: 'More menu',
    },
    dash: {
      title: 'System Dashboard',
      titleGroup: 'Group Dashboard',
      titleMember: 'My Contributions',
      subtitleSuper: 'Overview of all groups, members, and finances.',
      subtitleAdmin: 'Track members, contributions, and group trends quickly.',
      subtitleMember: 'Here you can see your contribution history and trends.',
      badgeSuper: 'Super Admin',
      badgeAdmin: 'Group Admin',
      badgeMember: 'Member',
      members: 'Members',
      contributions: 'Transactions',
      groups: 'Groups',
      totalAll: 'Grand Total',
      monthlyFees: 'Monthly Fees',
      monthlyFeesDesc: 'Regular contributions only',
      entryFee: 'Entry Fee',
      entryFeeDesc: 'Group entry fees',
      totalAllDesc: 'Fees + Entry Fee combined',
      groupTransfers: 'Withdraws',
      groupTransfersDesc: 'Disbursed to members',
      netBalance: 'Group Balance',
      netBalanceDesc: 'Grand total minus disbursements',
      myContributions: 'Total Contributed',
      myCount: 'Number of Contributions',
      scrollDown: 'Scroll down',
      history: 'Contribution History',
      monthlyChart: 'Contributions by Month',
      noTransactions: 'No transactions yet',
      allGroups: 'All Groups',
      groupMembers: 'Members',
      groupTotal: 'Total',
      distCard: 'Group Distribution',
      distCardTitle: 'What Will I Get?',
      distCardDesc: 'See your share if the group dissolves',
      myFines: 'My Outstanding Fines',
      finesCard: 'You Have Fines to Pay',
      finesCardDesc: 'Tap to view and pay your fines',
      noFines: 'No fines at the moment',
    },
    members: {
      title: 'Members',
      addMember: '+ New Member',
      newMember: 'New Member',
      memberName: 'Full Name',
      phone: 'Phone Number',
      email: 'Email',
      joinDate: 'Join Date',
      role: 'Role',
      totalContributed: 'Contributions',
      entryFee: 'Entry Fee',
      paidFee: 'Not Paid',
      deleteConfirm: 'Delete this member?',
      searchPlaceholder: 'Search by name or phone...',
      noMembers: 'No members found',
      chooseGroupFirst: 'Select a group first',
      recordEntryFee: 'Record Entry Fee',
      entryFeeDesc: 'This fee will not count toward monthly contributions',
      entryFeeAmount: 'Entry Fee Amount (TZS)',
      defaultEntryFee: 'Default entry fee',
      sendSms: 'Send Login SMS',
      allMembers: 'All',
      oneBy: 'One',
      searchMember: 'Search name or number...',
      noMemberFound: 'No member found',
      smsPreview: 'SMS to be sent',
      sendAll: 'Send to All',
      send: 'Send',
      sending: 'Sending...',
      idNumber: 'ID Number',
      adding: 'Adding...',
      saving: 'Saving...',
      errAdd: 'Failed to add member',
      errEntryFee: 'Failed to record entry fee',
    },
    trans: {
      title: 'Contributions',
      import: 'Import CSV',
      addTransaction: '+ Record Contribution',
      recordTransaction: 'Record Contribution',
      transId: 'TRANS ID',
      receipt: 'Receipt',
      memberName: 'Member',
      amount: 'Amount (TZS)',
      type: 'Contribution Type',
      date: 'Date & Time',
      notes: 'Notes',
      source: 'Source',
      destination: 'Destination',
      filter: 'Filter',
      filterAll: '-- All Members --',
      filterAllTypes: '-- All Types --',
      dateFrom: 'From',
      dateTo: 'To',
      exportCsv: 'Export CSV',
      deleteConfirm: 'Delete this contribution?',
      noTransactions: 'No contributions',
      monthlyFees: 'History',
      entryFee: 'Entry Fee',
      totalAll: 'Grand Total',
      transCount: 'Transactions',
      records: 'records',
      pivotTab: 'Monthly Report',
      monthlyTab: 'By Month',
      listTab: 'List',
      member: 'Member',
      total: 'Total',
      monthTotal: 'Monthly Total',
      allocationNote: 'This report allocates payments to the earliest due month, as in the Monthly Report. Monthly fee is',
      search: 'Search',
      saving: 'Saving...',
      errRecord: 'Failed to record contribution',
      payments: 'payments',
      chooseGroup: '-- Select Member --',
    },
    groups: {
      title: 'Groups',
      addGroup: '+ New Group',
      newGroup: 'New Group',
      name: 'Group Name',
      namePlaceholder: 'e.g. BLESSING FAMILY',
      code: 'Group Code/Number',
      accountNumber: 'Account Number (M-Pesa / Bank)',
      accountPlaceholder: '060243280129',
      description: 'Description',
      cycleType: 'Cycle Type',
      members: 'Members',
      total: 'Total contributions',
      settings: 'Settings',
      viewDetail: 'View →',
      deleteConfirm: 'All members and transactions will be deleted.',
      noGroups: 'No groups yet. Create a new group.',
      creating: 'Creating...',
      create: 'Create',
      errCreate: 'Failed to create group',
      number: 'Number',
    },
    settings: {
      title: 'Settings',
      groupName: 'Group Name',
      groupCode: 'Group Code',
      cycleType: 'Group Cycle',
      startDate: 'Start Date (First Contribution Month)',
      endDate: 'End Date',
      contributionsFrom: 'Count Contributions From',
      contributionsFromNote: 'contributions before this date are excluded (leave blank for default)',
      monthlyContribution: 'Monthly Fee (TZS)',
      entryFee: 'Entry Fee (TZS)',
      entryFeeNote: 'will not count toward monthly fees',
      openingBalance: 'Opening Balance (TZS)',
      openingBalanceNote: 'funds held before records began',
      dissolveAtEnd: 'Group dissolves at end of cycle (distribute funds)',
      reserveMonths: 'Reserve how many months before distribution?',
      reserveZero: '(0 = distribute all)',
      reserveMonthsNote: 'Fees for {n} months will be kept as start of next cycle. The first {n} months of the new cycle also won\'t count as dues owed (grace months).',
      dueDay: 'Monthly Payment Due Day',
      dueDayNote: 'of each month',
      graceDays: 'Grace Period',
      graceDaysNote: 'days',
      fineType: 'Fine Type',
      fineFixed: 'Fixed Amount (TZS)',
      finePercent: 'Percentage (%)',
      fineAmount: 'Fine Amount (TZS)',
      finePercentLabel: 'Fine Percentage (%)',
      finePercentNote: '% of monthly fee',
      fineAuto: 'Auto-apply fines',
      fineAutoNote: 'System will apply fines automatically when fines page is opened',
      leaders: 'Group Leaders',
      leadersDesc: 'Select members holding leadership positions. Their names will appear on the group page.',
      chooseLeader: '— Select member —',
      saveLeaders: 'Save Leaders',
      savingLeaders: 'Saving...',
      saveCycle: 'Save Cycle',
      savingCycle: 'Saving...',
      saveFine: 'Save Fine Settings',
      savingFine: 'Saving...',
      changiwaTypes: 'Changiwa Types (Rules)',
      changiwaTypesDesc: 'Define special contribution types — each member will be required to pay this amount for an event.',
      noChangiwaTypes: 'No changiwa types yet',
      addChangiwaType: '+ Add Changiwa Type',
      addNewType: 'Add New Type',
      typeName: 'Name',
      typeAmount: 'Amount per Member (TZS)',
      typeDesc: 'Description (optional)',
      typeNamePlaceholder: 'e.g. Bereavement',
      typeAmountPlaceholder: 'e.g. 5000',
      typeDescPlaceholder: 'e.g. Immediate family bereavement',
      transferTypes: 'Group Transfer Types',
      transferTypesDesc: 'Define payout types disbursed directly from the group fund to eligible members — e.g. bereavement, wedding, illness.',
      noTransferTypes: 'No transfer types yet',
      addTransferType: '+ Add Transfer Type',
      addNewTransferType: 'Add New Transfer Type',
      transferTypeName: 'Payout Name',
      transferTypeAmount: 'Amount Disbursed (TZS)',
      transferTypeDesc: 'Description (optional)',
      transferTypeNamePlaceholder: 'e.g. Bereavement, Wedding, Illness',
      transferTypeAmountPlaceholder: 'e.g. 800000',
      transferTypeDescPlaceholder: 'e.g. Bereavement benefit for immediate family',
      sms: 'Group Communications',
      smsDesc: 'Send SMS messages so members know how to log in via OTP.',
      smsSendAll: 'Send to All Members',
      smsSendOne: 'Send to This Member',
      smsSending: 'Sending...',
      smsPreview: 'SMS to be sent:',
      searchMember: 'Search name or phone...',
      noMemberFound: 'No member found',
      toastSavedCycle: 'Cycle settings saved',
      toastSavedFine: 'Fine settings saved',
      toastSavedLeaders: 'Leaders saved',
      toastSavedPerms: 'Member permissions saved',
      toastErr: 'Failed to save',
      toastErrLeaders: 'Failed to save leaders',
      fineInfo: 'The system will check each month whether members have paid. Those who have not paid after the set date + grace days will be fined.',
      months: 'months',
      memberPermsTitle: 'Member Permissions',
      memberPermsDesc: 'Select which pages members are allowed to see.',
      savePerms: 'Save Permissions',
    },
    groupDetail: {
      members: 'Members',
      totalContributions: 'Total Contributions',
      transactions: 'Transactions',
      groupTransfers: 'Withdraws',
      netBalance: 'Group Balance',
      kiingilio: 'Entry Fees',
      cycle: 'Cycle',
      monthlyFee: 'Monthly Fee',
      leaders: 'Group Leaders',
      notFound: 'Group not found',
      viewMembers: 'Members',
      viewContributions: 'Contributions',
      viewFines: 'Fines',
      viewChangiwa: 'Changiwa',
      viewImport: 'Import CSV',
      viewMonthly: 'Monthly Report',
      viewDistribution: 'Distribution',
      viewSettings: 'Settings',
      viewExpenses: 'Expenses',
      expenses: 'Group Expenses',
      noMembers: 'No members yet',
      totalContributed: 'Total Contributed',
    },
    fines: {
      title: 'Member Fines',
      subtitle: 'Track pending, waived, and paid fines for each member.',
      badgeLabel: 'Penalty Control',
      checkFines: 'Check Monthly Fines',
      checking: 'Checking...',
      addFine: '+ Add Fine',
      manualFine: 'Add Fine Manually',
      member: 'Member',
      period: 'Month',
      reason: 'Reason',
      reasonPlaceholder: 'e.g. Late payment for January',
      amount: 'Amount (TZS)',
      type: 'Type',
      statusLabel: 'Status',
      actions: 'Actions',
      pending: 'Pending',
      paid: 'Paid',
      waived: 'Waived',
      pay: 'Pay',
      waive: 'Waive',
      delete: 'Delete',
      deleteConfirm: 'Delete this fine?',
      noFines: 'No fines',
      pendingCount: 'Pending',
      pendingCountLabel: 'number of fines',
      pendingTotal: 'Total',
      pendingTotalLabel: 'TZS pending',
      chooseGroup: '-- Group --',
      allStatus: '-- All Statuses --',
      auto: 'Auto',
      manual: 'Manual',
      fineMonth: 'Month',
      fineMember: 'Month',
      saving: 'Saving...',
      submit: 'Add Fine',
      errCreate: 'Failed to add fine',
      chooseFirst: 'Select a group first',
      chooseSelect: '-- Select --',
    },
    cal: {
      title: 'Contribution Calendar',
      noEvents: 'Click a day to see contributions',
      noPaymentsDay: 'No contributions on this day',
      topContributors: 'Top Contributors This Month',
      summary: 'Summary',
      totalMonth: 'TZS collected',
      daysReceived: 'received contributions',
      dayTotal: 'Day Total',
      monthTotal: 'Total',
      daysWithPayments: '{n} days of payments',
      less: 'Less',
      more: 'More',
      payments: 'payments',
      chooseGroup: 'Select a group first',
    },
    changiwa: {
      title: 'Changiwa',
      addEvent: '+ New Event',
      newEvent: 'New Changiwa Event',
      noTypes: 'No changiwa types configured.',
      goSettings: 'Go to Settings',
      noEvents: 'No changiwa events yet.',
      noEventsHint: 'Click "+ New Event" to start.',
      typeLabel: 'Changiwa Type',
      typeSelect: '-- Select type --',
      title_label: 'Event Title',
      titlePlaceholder: 'e.g. Bereavement of JACKSON MMASI\'s mother',
      beneficiary: 'Beneficiary (optional)',
      beneficiarySelect: '-- Select or leave empty --',
      eventDate: 'Date',
      amountPerMember: 'Amount per Member (TZS)',
      amountNote: '{n} members × amount = expected total',
      notes: 'Notes (optional)',
      paid: 'paid',
      disbursed: 'Paid to Beneficiary',
      disbursedNote: 'recorded as group expense',
      viewPayments: 'View Payments',
      close: 'Close',
      deleteConfirm: 'All payments will be deleted.',
      creating: 'Creating...',
      createEvent: 'Create Event',
      errCreate: 'Failed to create event',
      chooseGroup: 'Select a group first',
    },
    changiwaDetail: {
      back: 'Changiwa',
      notFound: 'Event not found',
      beneficiary: 'Beneficiary',
      collected: 'paid',
      progress: 'collected',
      expected: 'Expected',
      disbursed: 'Paid to Beneficiary',
      disbursedNote: 'recorded as group expense',
      payAll: 'Mark All as Paid',
      disburse: 'Pay to',
      pending: 'Not Paid',
      paidSection: 'Paid',
      waived: 'Waived',
      pay: 'Pay',
      waive: 'Waive',
      confirmPayAll: 'Mark everyone as paid?',
      disbursedAt: 'recorded as group expense',
    },
    dist: {
      title: 'Fund Distribution',
      subtitle: 'Summary of income, expenses, and each member\'s share at end of cycle.',
      totalCollected: 'Total contributions collected',
      finesIncome: 'Fines paid (income)',
      totalIncome: 'Total income',
      expenses: 'Group expenses',
      groupTransfersDed: 'Death benefit payouts (Group Transfer)',
      reserve: 'Reserve ({n} months × {m} members)',
      toDistribute: 'Amount to distribute',
      summary: 'Financial Summary',
      currentBalance: 'Actual group balance (M-Pesa)',
      reserveNeeded: 'Reserve required ({n} months)',
      reserveSurplus: 'Reserve surplus',
      reserveShortfall: 'Reserve shortfall',
      myShare: 'My Share',
      contributed: 'I contributed',
      pendingFines: 'Pending fine',
      perMember: 'Distribution per Member',
      alreadyDistributed: 'This cycle is closed and funds have been distributed.',
      closeCycle: 'Close Cycle and Distribute Funds',
      closing: 'Closing...',
      closeWarning: 'After distributing funds, click the button below to close this cycle. The group will start a new cycle.',
      confirmClose: 'Are you sure you want to close this cycle? This action cannot be undone.',
      receives: 'Receives',
      totalDist: 'Total to Distribute',
      pendingFinesCol: 'Pending Fine',
      contributedCol: 'Contributed',
      memberCol: 'Member',
      me: 'Me',
    },
    importCsv: {
      title: 'Import M-Pesa CSV',
      back: 'Back',
      instructions: 'Instructions:',
      instrStep1: 'Download CSV from M-Pesa / CBS',
      instrStep2: 'Required columns: TRANS_ID, RECEIPT, DATE, MEMBER NAME, MEMBER ID, SOURCE, DESTINATION, AMOUNT, TRANS TYPE',
      instrStep3: 'Existing transactions (same TRANS_ID) will be skipped',
      instrStep4: 'New members will be created automatically from phone numbers',
      groupLabel: 'Group',
      groupSelect: '-- Select Group --',
      fileLabel: 'CSV File',
      fileClick: 'Click here to select a CSV file',
      fileDrop: 'or drag & drop',
      submit: 'Import CSV',
      submitting: 'Importing...',
      success: 'Completed!',
      imported: 'Transactions imported',
      skipped: 'Skipped (already exists)',
      viewTransactions: 'View Contributions →',
      errNoGroup: 'Select a group first',
      errNoFile: 'Select a CSV file',
      errImport: 'Failed to import CSV',
    },
    users: {
      title: 'Users',
      addUser: '+ New User',
      newUser: 'New User',
      fullName: 'Full Name',
      phone: 'Phone Number',
      phonePlaceholder: '255715465042',
      phoneNote: 'Use format `255XXXXXXXXX`. If you enter `07XXXXXXXX`, the system will convert it to `255XXXXXXXXX` before saving.',
      password: 'Password',
      role: 'Role',
      group: 'Group',
      groupSelect: '-- Select --',
      active: 'Active',
      inactive: 'Suspended',
      status: 'Status',
      roleLabel: 'Role',
      superadmin: 'Super Admin',
      adminGroup: 'Group Admin',
      memberRole: 'Member',
      deleteConfirm: 'Delete user',
      noUsers: 'No users',
      creating: 'Creating...',
      create: 'Create',
      errCreate: 'Failed to create user',
      errPhone: 'Phone number must be in the format 255XXXXXXXXX',
      errSave: 'Failed to save changes',
      editUser: 'Edit User',
      newPassword: 'New Password',
      optional: 'optional',
      passwordPlaceholder: 'Leave blank to keep unchanged',
      addToGroup: 'Add Group',
      addToGroupTitle: 'Add User to Group',
      addToGroupSub: 'User will be able to switch between their groups',
      selectRole: 'Select Role',
      addToGroupBtn: 'Add',
      addingToGroup: 'Adding...',
      errAddToGroup: 'Failed to add to group',
      addToGroupSuccess: 'Added to new group',
      memberRoles: {
        mwenyekiti: 'Mwenyekiti (Admin)',
        katibu: 'Katibu (Secretary)',
        mwekahazina: 'Mweka Hazina (Treasurer)',
        mwanachama: 'Mwanachama (Member)',
      },
    },
    report: {
      title: 'Monthly Report',
      subtitle: 'See each member\'s status for all months, gaps, full payments, and partial payments.',
      member: 'Member',
      total: 'Total',
      totalMonth: 'Monthly Total',
      paid: 'Paid',
      paidCells: 'paid cells',
      gap: 'Gap',
      gapCells: 'unpaid',
      partial: 'Partial',
      partialCells: 'partial payments',
      feeLabel: 'Fee',
      membersWithGaps: 'Members with Gaps',
      gapLabel: 'Gaps',
      debtLabel: 'Debt',
      openReport: 'Open',
      reportCalendar: 'Report Calendar',
      reportCalendarHint: 'Click to open fullscreen to see all months.',
      closeFS: 'Close',
      gapCount: 'gap',
      cannotShow: 'Cannot display report',
      goSettings: 'Go to Settings →',
    },
    memberDetail: {
      title: 'Member summary, monthly status, and contribution history.',
      back: 'Members',
      phone: 'Phone',
      email: 'Email',
      role: 'Role',
      status: 'Status',
      active: 'Active',
      inactive: 'Suspended',
      joined: 'Joined',
      totalContributed: 'Total Contributed',
      countContributions: 'Number of Contributions',
      msibaPaid: 'Death Benefit Received',
      balance: 'Ahead / Even',
      debt: 'Debt',
      gapMonths: 'Months Unpaid',
      monthlyStatus: 'Monthly Status',
      history: 'Contribution History',
      noTransactions: 'No contributions yet',
      notFound: 'Member not found',
      statusPaid: 'Paid',
      statusPartial: 'Partial',
      statusGap: 'Not Paid',
      statusFuture: 'Upcoming',
    },
    expenses: {
      title: 'Group Expenses',
      subtitle: 'Operating costs and death benefit payments',
      summaryRegular: 'Regular Expenses',
      summaryMsiba: 'Death Benefits',
      addBtn: '+ Add New Payment',
      formTitle: 'New Payment',
      typeLabel: 'Payment Type',
      typeRegular: '🧾 Regular Expense',
      typeMsiba: '🏥 Death Benefit Payment',
      msibaTypeLabel: 'Bereavement Type',
      msibaTypeSelect: '— Select bereavement type —',
      memberLabel: 'Beneficiary Member *',
      memberSelect: '— Select member —',
      descLabel: 'Description *',
      descPlaceholder: 'e.g. Meeting costs, Transport…',
      notesLabel: 'Additional Notes (optional)',
      notesLabelMsiba: 'Additional Notes',
      notesPlaceholderMsiba: "e.g. Member's mother passed away",
      notesPlaceholder: 'Any additional notes…',
      typesMgmt: 'Bereavement Types',
      typesCount: 'types configured',
      typesEmpty: 'No types added yet',
      typeNamePlaceholder: 'Type name (e.g. Aunt bereavement)',
      typeAmountPlaceholder: 'Amount',
      typeAddBtn: '+ Add',
      sectionRegular: '🧾 Regular Expenses',
      sectionMsiba: '🏥 Death Benefits',
      noRegular: 'No expenses recorded yet',
      noMsiba: 'No death benefit payments recorded yet',
      deleteExpenseConfirm: 'Delete this expense?',
      errAmount: 'Enter a valid amount',
      errMember: 'Select a member',
      errDesc: 'Enter a description',
      errSave: 'Failed to save',
      saving: 'Saving…',
      close: 'Close',
    },
    gt: {
      title: 'Withdraws',
      subtitle: 'Members who received group support',
      totalDisbursed: 'Total Disbursed',
      payments: 'payments',
      addBtn: '+ Add Payment',
      addModalTitle: 'Add Support Payment',
      editModalTitle: 'Edit Payment',
      memberLabel: 'Member Who Received Support',
      memberSelect: '— Select member —',
      subTypeLabel: 'Type of Support',
      amountLabel: 'Amount (TZS)',
      amountPlaceholder: 'e.g. 50000',
      dateLabel: 'Date',
      notesLabel: 'Notes',
      notesPlaceholder: "e.g. Mother's funeral / Child's wedding",
      cancel: 'Cancel',
      save: 'Save',
      saving: 'Saving...',
      edit: 'Edit',
      delete: 'Delete',
      empty: 'No payments recorded yet',
      total: 'Total',
      colMember: 'Member Name',
      colPhone: 'Phone',
      colType: 'Type',
      colAmount: 'Amount',
      colDate: 'Date',
      colNotes: 'Notes',
      errMember: 'Select a member',
      errAmount: 'Enter a valid amount',
      errSave: 'Failed to save',
      errEdit: 'Failed to update',
      errDelete: 'Failed to delete',
      confirmDelete: 'Delete payment for',
      confirmDeleteMsg: 'This will remove the record from the system.',
    },
    registerGroup: {
      title: 'Register New Group',
      subtitle: 'Request will be sent to superadmin for approval',
      labelGroupName: 'Group Name',
      placeholderGroupName: 'e.g. BLESSINGS FAMILY',
      labelMemberCount: 'Number of Members',
      placeholderMemberCount: 'e.g. 15',
      sectionChair: 'Chairperson Details',
      labelChairName: 'Full Name',
      placeholderChairName: 'Chairperson name',
      labelChairPhone: 'Phone Number',
      phoneHint: 'This number will be the group admin and will receive an invitation SMS',
      btnSubmit: 'Submit Request →',
      btnSubmitting: 'Submitting...',
      successTitle: 'Request Received!',
      successMsg: 'The superadmin will review your request and you will be notified via SMS once approved.',
      btnClose: 'OK, Thank you!',
      errRequired: 'Please fill in all required fields',
      errDuplicate: 'Your request is still pending. Wait for superadmin approval.',
      errPhoneExists: 'This phone number is already registered in the system. Please log in or contact the administrator.',
      errGeneric: 'Failed to submit request. Please try again.',
    },
    groupRequests: {
      title: 'Group Requests',
      subtitle: 'Groups requesting to join the system',
      filterPending: 'Pending',
      filterApproved: 'Approved',
      filterRejected: 'Rejected',
      filterAll: 'All',
      loading: 'Loading...',
      empty: 'No requests found',
      labelGroupName: 'Group',
      labelChair: 'Chairperson',
      labelPhone: 'Phone',
      labelMembers: 'Members',
      labelGroupId: 'Group ID',
      labelRejectionNote: 'Rejection reason',
      btnApprove: '✅ Approve Group',
      btnApproving: 'Approving...',
      btnReject: '❌ Reject',
      rejectTitle: 'Reject Request',
      rejectLabel: 'Reason (will be sent via SMS)',
      rejectPlaceholder: 'Enter reason here (optional)...',
      btnConfirmReject: 'Reject',
      btnRejecting: 'Rejecting...',
      btnCancel: 'Cancel',
      toastApproved: 'Group approved and SMS sent to chairperson!',
      toastRejected: 'Request rejected.',
      statusPending: 'Pending',
      statusApproved: 'Approved',
      statusRejected: 'Rejected',
    },
    auditLog: {
      title: 'Audit Trail',
      subtitle: 'All actions performed by system users',
      searchPlaceholder: 'Search by name, phone or description…',
      allActions: 'All actions',
      from: 'From',
      to: 'To',
      clearFilters: 'Clear filters',
      totalRecords: 'Total records',
      loading: 'Loading…',
      noData: 'No records found',
      prev: 'Previous',
      next: 'Next',
      page: 'Page',
      col: {
        time: 'Time',
        user: 'User',
        role: 'Role',
        action: 'Action',
        description: 'Description',
        ip: 'IP Address',
      },
      actions: {
        login: 'Login',
        create_transaction: 'Add Contribution',
        delete_transaction: 'Delete Contribution',
        create_member: 'Add Member',
        update_member: 'Update Member',
        delete_member: 'Delete Member',
        create_expense: 'Add Expense',
        delete_expense: 'Delete Expense',
        update_user: 'Update User',
        delete_user: 'Delete User',
        update_permissions: 'Update Permissions',
      },
    },
    systemSettings: {
      title: 'System Settings',
      subtitle: 'Configure WhatsApp and SMS credentials to send notifications to members.',
      noChanges: 'No changes.',
      hasChanges: 'You have unsaved changes.',
      save: 'Save',
      saving: 'Saving...',
      saved: '✅ Settings saved!',
      saveFailed: '❌ Failed to save.',
      loadFailed: 'Failed to load settings.',
      change: 'Change',
      set: '+ Set',
      notSet: 'Not set',
      testTitle: '🧪 Test Connection',
      testPhone: 'Test phone number (255...)',
      test: 'Test',
      testing: '...',
      testOk: '✅',
      testFail: '❌',
      providerLabel: 'WhatsApp Provider',
      providerHint: 'Select which provider to use when sending WhatsApp messages.',
      providers: { ultramsg: 'UltraMsg', wasender: 'WasenderAPI', meta: 'Meta (Official)' },
      whatsapp: {
        title: 'WhatsApp — UltraMsg',
        hint: 'Log in to ultramsg.com, create an instance, then copy the Instance ID and Token here.',
        link: 'ultramsg.com ↗',
        fields: {
          whatsapp_instance_id: 'Instance ID',
          whatsapp_token: 'Token',
          whatsapp_url: 'API URL',
        },
      },
      wasender: {
        title: 'WhatsApp — WasenderAPI',
        hint: 'Log in to app.wasenderapi.com, create a session, then copy your API Key here.',
        link: 'wasenderapi.com ↗',
        fields: {
          wasender_api_key: 'API Key',
        },
      },
      meta: {
        title: 'WhatsApp — Meta (Official)',
        hint: 'Create an App at developers.facebook.com, add the "WhatsApp" product, then copy a permanent Access Token and the Phone Number ID from WhatsApp → API Setup. Then set the Callback URL and Verify Token below in your App\'s "Webhook" section.',
        link: 'developers.facebook.com ↗',
        callbackLabel: 'Callback URL (Webhook)',
        fields: {
          meta_whatsapp_token: 'Access Token',
          meta_whatsapp_phone_number_id: 'Phone Number ID',
          meta_whatsapp_waba_id: 'WhatsApp Business Account ID (WABA ID)',
          meta_whatsapp_verify_token: 'Webhook Verify Token',
        },
      },
      sms: {
        title: 'SMS (messaging-service.co.tz)',
        hint: 'NexByte/messaging-service.co.tz account — contact your SMS provider for credentials.',
        fields: {
          sms_username: 'Username',
          sms_password: 'Password',
          sms_from: 'Sender Name (From)',
        },
      },
    },
    smsLogs: {
      title: 'SMS Logs',
      subtitle: 'View all SMS sent by the system — successful and failed',
      searchPlaceholder: 'Search phone number or message…',
      allStatus: 'All status',
      sent: 'Sent',
      failed: 'Failed',
      from: 'From',
      to: 'To',
      clearFilters: 'Clear filters',
      totalRecords: 'Total SMS',
      loading: 'Loading…',
      noData: 'No SMS records found',
      prev: 'Previous',
      next: 'Next',
      page: 'Page',
      viewDetails: 'View details',
      hideDetails: 'Hide',
      col: {
        time: 'Time',
        phone: 'Phone Number',
        message: 'Message',
        status: 'Status',
        error: 'Error',
      },
    },
    perms: {
      title: 'Access Control',
      subtitle: 'Configure what members and group admins can see and do',
      selectGroup: 'Select Group',
      memberTitle: 'Member Visibility',
      memberDesc: 'Pages that a member can view',
      adminTitle: 'Admin Actions',
      adminDesc: 'Actions that a group admin can perform',
      allOn: 'All On',
      allOff: 'All Off',
      save: 'Save Permissions',
      saved: 'Saved',
      saveHint: 'Changes take effect immediately',
      member: {
        transactions:   { label: 'Contributions',  desc: 'Can view their contributions' },
        fines:          { label: 'Fines',           desc: 'Can view their fines' },
        changiwa:       { label: 'Changiwa',        desc: 'Can view changiwa events' },
        monthly_report: { label: 'Monthly Report',  desc: 'Can view monthly payment report' },
        distribution:   { label: 'Distribution',   desc: 'Can view cycle distribution' },
      },
      admin: {
        add_transactions:    { label: 'Add Contributions',    desc: 'Can enter new contributions' },
        delete_transactions: { label: 'Delete Contributions', desc: 'Can delete contributions' },
        add_members:         { label: 'Add Members',          desc: 'Can add new members' },
        deactivate_members:  { label: 'Deactivate Members',   desc: 'Can deactivate members' },
        delete_members:      { label: 'Delete Members',       desc: 'Can permanently delete members' },
        manage_fines:        { label: 'Manage Fines',         desc: 'Can add/pay/delete fines' },
        manage_changiwa:     { label: 'Manage Changiwa',      desc: 'Can create and manage events' },
        manage_expenses:     { label: 'Manage Expenses',      desc: 'Can add and delete expenses' },
        import_csv:          { label: 'Import CSV',           desc: 'Can import contributions via CSV' },
      },
    },
    errLoad: 'Failed to load',
    errSave: 'Failed to save',
    errDelete: 'Failed to delete',
    errNetwork: 'Network error',
  },
};

export default translations;
